<c-container fluid class="p-4">
  <c-row>
    <c-col xs="12">
      <c-card class="mb-4">
        <c-card-header>
          <strong>{{ 'earningsStatistics.title' | translate }}</strong>
        </c-card-header>

        <c-card-body>
          <!-- Loading State -->
          @if (loading()) {
            <div class="text-center py-4">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">{{ 'earningsStatistics.loading' | translate }}</span>
              </div>
            </div>
          }

          <!-- Error State -->
          @if (error(); as err) {
            <div class="alert alert-danger" role="alert">
              {{ err }}
              <button class="btn btn-sm btn-primary ms-3" (click)="loadStatistics()">
                {{ 'earningsStatistics.retry' | translate }}
              </button>
            </div>
          }

          <!-- Statistics Matrix -->
          @if (!loading() && !error() && statisticsData() && activeLevels().length > 0) {
            @let periodsData = periods();
            @let levels = activeLevels();

            <div class="mb-3 d-flex gap-3 flex-wrap legend-container">
              <div class="d-flex align-items-center gap-2">
                <span class="badge bg-success">{{ 'earningsStatistics.legend.comCard' | translate }}</span>
                <small class="legend-text">{{ 'earningsStatistics.legend.comCardDesc' | translate }}</small>
              </div>
              <div class="d-flex align-items-center gap-2">
                <span class="badge bg-info">{{ 'earningsStatistics.legend.comLic' | translate }}</span>
                <small class="legend-text">{{ 'earningsStatistics.legend.comLicDesc' | translate }}</small>
              </div>
            </div>

            <div class="table-responsive">
              <table cTable [hover]="true" [striped]="true" class="statistics-matrix">
                <thead>
                  <tr>
                    <th class="sticky-col">{{ 'earningsStatistics.period' | translate }}</th>
                    <th class="sticky-col-2">{{ 'earningsStatistics.level' | translate }}</th>
                    <th class="text-center">{{ 'earningsStatistics.comCard' | translate }}</th>
                    <th class="text-center">{{ 'earningsStatistics.comLic' | translate }}</th>
                    <th class="text-center">{{ 'earningsStatistics.poolPayout' | translate }}</th>
                    <th class="text-center fw-bold bg-light">{{ 'earningsStatistics.total' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  @for (periodData of periodsData; track periodData.period; let isFirst = $first) {
                    @for (level of levels; track level; let isFirstLevel = $first) {
                      <tr [class.border-top-bold]="isFirst && isFirstLevel">
                        @if (isFirstLevel) {
                          <td class="sticky-col fw-bold" [attr.rowspan]="levels.length">
                            {{ getPeriodLabel(periodData.period) | translate }}
                          </td>
                        }
                        <td class="sticky-col-2">{{ 'earningsStatistics.level' | translate }} {{ level }}</td>
                        <td class="text-end">{{ formatAmount(getLevelData(periodData, level).com_card) }}</td>
                        <td class="text-end">{{ formatAmount(getLevelData(periodData, level).com_lic) }}</td>
                        <td class="text-end"></td>
                        <td class="text-end fw-bold bg-light">
                          {{ formatAmount(getLevelData(periodData, level).total) }}
                        </td>
                      </tr>
                    }

                    <!-- Total row for this period -->
                    <tr class="border-bottom-bold bg-totals">
                      <td class="sticky-col" *ngIf="levels.length > 0"></td>
                      <td class="sticky-col-2 fw-bold text-end">{{ 'earningsStatistics.totals' | translate }}:</td>
                      <td class="text-end fw-bold">{{ formatAmount(getTotalForPeriod(periodData).com_card) }}</td>
                      <td class="text-end fw-bold">{{ formatAmount(getTotalForPeriod(periodData).com_lic) }}</td>
                      <td class="text-end fw-bold">{{ formatAmount(getTotalForPeriod(periodData).pool_payout) }}</td>
                      <td class="text-end fw-bold bg-primary text-white">
                        {{ formatAmount(getTotalForPeriod(periodData).total) }}
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }

          <!-- No Data State -->
          @if (!loading() && !error() && statisticsData() && activeLevels().length === 0) {
            <div class="text-center py-4 text-muted">
              {{ 'earningsStatistics.noData' | translate }}
            </div>
          }
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>
</c-container>